import React from 'react';
import { noop, get, head } from 'lodash-es';
import { connect } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { Multiselect } from '@is24at/react-gac/src';
import { SuggestionType } from '@is24at/react-gac/src/constants';
import { EMPTY_STRING } from '@is24at/react-constants';
import GacClient from 'api/gacApiClient';
import splitGacValues from 'routes/ResultList/modules/transformers/gacValues';
import {
  byInitialValues,
  byGacSpot,
} from 'routes/ResultList/modules/resultList';
import { SearchParamsEnum } from 'utils/enums';

const DEFAULT_SUGGESTIONS = [
  {
    label: 'Wien',
    value: '009001',
    type: SuggestionType.CITY,
  },
  {
    label: 'Burgenland',
    value: '001',
    type: SuggestionType.REGION,
  },
  {
    label: 'Kärnten',
    value: '002',
    type: SuggestionType.REGION,
  },
  {
    label: 'Niederösterreich',
    value: '003',
    type: SuggestionType.REGION,
  },
  {
    label: 'Oberösterreich',
    value: '004',
    type: SuggestionType.REGION,
  },
  {
    label: 'Salzburg',
    value: '005',
    type: SuggestionType.REGION,
  },
  {
    label: 'Steiermark',
    value: '006',
    type: SuggestionType.REGION,
  },
  {
    label: 'Tirol',
    value: '007',
    type: SuggestionType.REGION,
  },
  {
    label: 'Vorarlberg',
    value: '008',
    type: SuggestionType.REGION,
  },
] as Item[];

const findGACSuggestionsBySearch = (searchString: any) => ({
  promise: GacClient.queryGACService(searchString).then((result: any) =>
    get(result, 'hits', []),
  ),

  cancel: noop,
});

const GeoAutoComplete = (props: any) => {
  const { setValue } = useFormContext();

  const handleChange = (nextValues: any) => {
    const nextValue = head(nextValues);

    if (!nextValue) {
      setValue(SearchParamsEnum.region, EMPTY_STRING);
      setValue(SearchParamsEnum.zipCode, EMPTY_STRING);
      setValue(SearchParamsEnum.spot, EMPTY_STRING);
      return;
    }

    const { region, zipCode, spot } = splitGacValues(nextValue);
    setValue(SearchParamsEnum.region, region);
    setValue(SearchParamsEnum.zipCode, zipCode);
    setValue(SearchParamsEnum.spot, spot);
  };

  return (
    <Multiselect
      fetchEntityContextFn={noop}
      defaultSuggestions={DEFAULT_SUGGESTIONS}
      isFocused={false}
      placeholder="Postleitzahl, Ort"
      queryFn={findGACSuggestionsBySearch}
      isSingleSelect
      handleChange={handleChange}
      {...props}
    />
  );
};

// ---
// Connect.
// ---
const mapStateToProps = (state: any) => ({
  initialValues: byGacSpot(byInitialValues(state)),
});

export default connect(mapStateToProps)(GeoAutoComplete);
